<template>
  <div id="center-1">
    <div class="first">
      <div class="word">总营业额</div>
      <div class="sum-num">
        <div :class="[item == ',' || item == '.' ? 'color-bg' : 'fill-bg']" v-for="(item, index) in showList" :key="index">
          <span class="num-clor">
            {{ item }}
          </span>
        </div>
      </div>
      <div class="word">元</div>
    </div>
    <div class="row">
      <!-- 设备总数 -->
      <div class="row-item">
        <div class="num">{{chargingCount}}</div>
        <div class="tip">设备总数(台)</div>
        <div class="img">
          <img src="../../assets/pgzl-device-bg.png" alt="" />
        </div>
      </div>
      <!-- 端口总数 -->
      <div class="row-item">
        <div class="num">{{socketCount}}</div>
        <div class="tip">端口总数(个)</div>
        <div class="img">
          <img src="../../assets/pgzl-socket-bg-2.png" alt="" />
        </div>
      </div>
      <!-- 用电总度数 -->
      <div class="row-item">
        <div class="num">{{totalElectricity}}</div>
        <div class="tip">用电总度数(度)</div>
        <div class="img">
          <img src="../../assets/pgzl-meter-bg.png" alt="" />
        </div>
      </div>
      <!-- 覆盖城市 -->
      <div class="row-item">
        <div class="num">{{regionCount}}</div>
        <div class="tip">覆盖城市(个)</div>
        <div class="img">
          <img src="../../assets/pgzl-city-bg.png" alt="" />
        </div>
      </div>
      <!-- 用户总数 -->
      <div class="row-item">
        <div class="num">{{memberCount}}</div>
        <div class="tip">用户总数(人)</div>
        <div class="img">
          <img src="../../assets/pgzl-user-bg.png" alt="" />
        </div>
      </div>
      <!-- 今日订单数 -->
      <div class="row-item">
        <div class="num">{{orderCount}}</div>
        <div class="tip">今日订单数(个)</div>
        <div class="img">
          <img src="../../assets/pgzl-order-bg.png" alt="" />
        </div>
      </div>
      <!-- 今日营业额 -->
      <div class="row-item">
        <div class="num">{{orderAmount}}</div>
        <div class="tip">今日营业额(元)</div>
        <div class="img">
          <img src="../../assets/pgzl-turnover-2.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { timerSeter } from "@/utils";
export default {
  props: ["level", "regionId", "deviceType"],
  data() {
    return {
      timer: null,
      showList: [],
      totalTurnover: "", //总营业额
      totalElectricity: 0, //总用电量
      chargingCount: 0, //设备总数
      socketCount: 0, //端口总数
      regionCount: 0, //覆盖城市数
      memberCount: 0, //用户总数
      orderCount: 0, //今日订单总数
      orderAmount: 0, //今日总营业额
    };
  },
  created() {
    this.getData();
    // this.timer = setInterval(() => {
    //   setTimeout(this.getData(), 0);
    // }, 1000 * 10);
  },
  mounted() {},
  methods: {
    formatNum(num) {
      let digNum = String(num).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
      this.showList = digNum.toString().split("");
    },
    getData() {
      this.$http({
        url: this.$http.adornUrl(
          "/admin/api/realTime/getRealTimeBasicDataByStatRegionBusiData"
        ),
        method: "get",
        params: this.$http.adornParams({
          findType: this.deviceType,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        if (data.code == 0) {
          if (this.deviceType == "") {
            // 总览
            this.totalTurnover = data.data.totalTurnover;
            this.totalElectricity = data.data.totalElectricity;
            this.memberCount = data.data.memberCount;
            this.orderCount = data.data.orderCount;
            this.orderAmount = data.data.orderAmount;
            this.chargingCount = data.data.chargingCount;
            this.socketCount = data.data.socketCount;
            this.regionCount = data.data.regionCount;
          } else if (this.deviceType == "0") {
            // 自行车充电桩
            this.totalTurnover = data.data.bevTotalTurnover;
            this.totalElectricity = data.data.bevTotalElectricity;
            this.memberCount = data.data.bevMemberCount;
            this.orderAmount = data.data.bevOrderAmount;
            this.chargingCount = data.data.bevChargingCount;
            this.socketCount = data.data.bevSocketCount;
            this.regionCount = data.data.bevRegionCount;
            this.orderCount = data.data.bevOrderCount;
          } else if (this.deviceType == "1") {
            // 汽车充电桩
            this.orderCount = data.data.nevOrderCount;
            this.totalTurnover = data.data.nevTotalTurnover;
            this.totalElectricity = data.data.nevTotalElectricity;
            this.memberCount = data.data.nevMemberCount;
            this.orderAmount = data.data.nevOrderAmount;
            this.chargingCount = data.data.nevChargingCount;
            this.socketCount = data.data.nevSocketCount;
            this.regionCount = data.data.nevRegionCount;
          }
        }
        this.formatNum(this.totalTurnover);
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>
<style lang="scss" scoped>
#center-1 {
  width: 100%;
  .first {
    display: flex;
    justify-content: center;
    text-align: center;
    margin-bottom: 28px;
    padding-left: 80px;
    .word {
      font-size: 20px;
      font-weight: bold;
      color: #75b8ff;
      line-height: 80px;
      letter-spacing: 4px;
      margin: 0 20px;
    }
    .sum-num {
      display: flex;
      justify-content: space-around;
      line-height: 80px;
    }
    .fill-bg {
      width: 50px;
      height: 70px;
      line-height: 70px;
      background: url("../../assets/pgzl-num-bg-1.png");
      background-size: 100% 100%;
      font-size: 40px;
      font-weight: bold;
      .num-clor {
        color: #00ecfc;
        text-shadow: 0px 2px 12px rgba(255, 187, 0, 0.44);
        background: linear-gradient(180deg, #fff8c8 0%, #f7b500 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .color-bg {
      font-size: 40px;
      font-weight: bold;
      color: #75b8ff;
    }
  }

  .row {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .row-item {
    text-align: center;
    .num {
      font-size: 20px;
      color: #fff;
      margin-bottom: 7px;
    }
    .tip {
      font-size: 12px;
      color: #00ecfc;
    }
    .img {
      width: 100%;
      height: 70px;
      img {
        width: 80px;
        height: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/center-1.vue